import React from 'react'
import styles from './HeroSection.module.css'

const HeroSection = ({ isActive, onStartDrawing }) => {
  return (
    <div className={`${styles.heroSection} ${isActive ? styles.active : ''}`}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.badge}>
            AI 기반 실시간 분석과 커뮤니티가 만나다
          </div>
          
          <h1 className={styles.title}>
            <span className={styles.titleGradient}>그림.</span>
            <span className={styles.titleBlack}> 으로 시작하는</span>
            <br />
            <span className={styles.titlePurple}>마음 치유.</span>
          </h1>

          <p className={styles.subtitle}>
            HTP, DAP 등 검증된 미술치료 기법과 AI 분석을 통해 자신을 이해하고,<br />
            게임의 요소와 커뮤니티를 통해 즐겁게 성장하세요.
          </p>

          <div className={styles.actions}>
            {/* <button 
              className={styles.primaryBtn}
              onClick={onStartDrawing}
            >
              <i className="fas fa-play"></i>
              무료 체험하기
            </button> */}
          </div>
        </div>

        <div className={styles.heroVisual}>
          <div className={styles.canvas}>
            <div className={styles.canvasFrame}>
              <div className={styles.drawingAnimation}>
                <svg width="300" height="200" viewBox="0 0 300 200">
                  <path
                    d="M50,150 Q100,50 150,100 T250,80"
                    stroke="#4f46e5"
                    strokeWidth="4"
                    fill="none"
                    strokeLinecap="round"
                    className={styles.animatedPath}
                  />
                  <circle cx="50" cy="150" r="6" fill="#f59e0b" className={styles.dot1} />
                  <circle cx="150" cy="100" r="8" fill="#ef4444" className={styles.dot2} />
                  <circle cx="250" cy="80" r="5" fill="#10b981" className={styles.dot3} />
                </svg>
              </div>
            </div>
            
            <div className={styles.tools}>
              <div className={styles.tool}>🎨</div>
              <div className={styles.tool}>✏️</div>
              <div className={styles.tool}>🖌️</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HeroSection